// extracted by mini-css-extract-plugin
export default {"adminDashboardBlock":"help_adminDashboardBlock__PsSTY","helpChatContainer":"help_helpChatContainer__echJD"};